import { getClosestTextContent } from "@editor/utils";

export const prepareStockImagesAiPrompt = () => {
  const closestContent = getClosestTextContent();
  if (!closestContent) return null;

  return `
    Act as a presentation designer.
    Your task is to find the most suitable image for a paragraph in your presentation. The image should capture the essence and emotion of the text, rather than just visually describing it.
    ======
    1. Read this text: "${closestContent}".
    2. Identify the most accurate and simple search term to use on Pexels.com or Unsplash. Provide only one option, consisting of only one word. you can add another word if the 2 are creating a well-known definition (e.g: "mount" vs "TV mount"). The search term should be simple, clearly reflect the spirit of the text and avoid any potential double meanings. It cannot be a company name, person name, place name, or professional phrase.
    3. Respond with the JSON object { "search": "search term" } and nothing else. Do not include any markdown formatting or triple backticks (\`\`\`)
  `;
};
